import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "2027.648 1252 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M2037.648 1262q-2.062 0-3.531-1.469-1.47-1.468-1.47-3.531 0-2.062 1.47-3.531t3.53-1.469q2.064 0 3.532 1.469 1.47 1.468 1.469 3.531t-1.469 3.531q-1.468 1.47-3.531 1.469m-10 10v-3.5q0-1.063.547-1.953a3.65 3.65 0 0 1 1.453-1.36 18.6 18.6 0 0 1 3.937-1.453 17.2 17.2 0 0 1 4.063-.484q2.063 0 4.062.484 2 .485 3.938 1.454a3.64 3.64 0 0 1 1.453 1.359q.547.891.547 1.953v3.5zm2.5-2.5h15v-1q0-.344-.172-.625a1.2 1.2 0 0 0-.453-.437 16.3 16.3 0 0 0-3.406-1.266 14.5 14.5 0 0 0-6.938 0 16.3 16.3 0 0 0-3.406 1.265 1.22 1.22 0 0 0-.625 1.063zm7.5-10q1.03 0 1.766-.734.735-.735.734-1.766 0-1.03-.734-1.766a2.4 2.4 0 0 0-1.766-.734q-1.032 0-1.766.734a2.4 2.4 0 0 0-.734 1.766q0 1.032.734 1.766.735.735 1.766.734m0 10",
      class: "fills",
      style: {"fill":"#456332","fill-opacity":"1"}
    }, null, -1)
  ]))]))
}
export default { render: render }